import { ACTIONS_FEATURE_PERMISSIONS_MAP } from './actionsFeaturePermissionsMap.constant';
import { CONFIGURATION_FEATURE_PERMISSIONS_MAP } from './configurationFeaturePermissionsMap.constant';
import { DASHBOARD_FEATURE_PERMISSIONS_MAP } from './dashboardFeaturePermissionsMap.constant';
import { DECISIONING_FEATURE_PERMISSIONS_MAP } from './decisioningFeaturePermissionsMap.constant';
import { DISPLAY_AND_EMAIL_FEATURE_PERMISSIONS_MAP } from './displayAndEmailFeaturePermissionsMap.constant';
import { ENTITY_DETAILS_FEATURE_PERMISSIONS_MAP } from './entityDetailsFeaturePermissionsMap.constant';

export const RBAC_FEATURE_PERMISSIONS_MAP = {
    ...DASHBOARD_FEATURE_PERMISSIONS_MAP,
    ...CONFIGURATION_FEATURE_PERMISSIONS_MAP,
    ...DISPLAY_AND_EMAIL_FEATURE_PERMISSIONS_MAP,
    ...ENTITY_DETAILS_FEATURE_PERMISSIONS_MAP,
    ...DECISIONING_FEATURE_PERMISSIONS_MAP,
    ...ACTIONS_FEATURE_PERMISSIONS_MAP,
};

